<template>
  <div id="app">
    <Header class="header" />

    <main class="main">      
      <router-view :key="$route.path"></router-view>
    </main>
  </div>
</template>

<script>
import Header from '@/components/Header'

export default {
  name: 'app',
  components: { Header }
}
</script>

<style lang="scss">
  @import "./assets/scss/style.scss";

  html, body {
    min-height: 100%;
    height: 100%;
  }
  html, body, #app {
    min-height: 100%;
  }
  #app {
    overflow: hidden;
  }

  .fade-enter-active, .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fade-enter-active {
    transition-delay: .25s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .content a {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue